import InfoIndicator, { type InfoIndicatorProps } from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';
import Label from '@ubnt/ui-components/Label/Label';
import Tooltip from '@ubnt/link-core-ui/components/Tooltip';
import { clsx } from 'clsx';
import { memo, useMemo } from 'react';

import ButtonPicker, { ButtonPickerProps } from 'components/ButtonPicker/ButtonPicker';
import { Flex } from 'components/Flex';

import classes from './TabsPicker.module.scss';

export interface TabsPickerProps extends ButtonPickerProps {
  className?: string;
  labelClassName?: string;
  label?: string;
  labelTooltip?: React.ReactNode;
  labelTooltipProps?: InfoIndicatorProps;
  testId?: string;
}

const TabsPicker = (props: TabsPickerProps) => {
  const {
    label,
    labelTooltip,
    labelTooltipProps,
    labelClassName,
    isDisabled,
    tooltipDescription,
    className,
    testId,
    ...rest
  } = props;

  const picker = useMemo(
    () => (
      <div className={clsx(classes.TabsPicker, className)} data-testid={testId}>
        <Label className={clsx(classes.label, labelClassName)} color="tertiary" disabled={isDisabled}>
          <Flex gap="xs" alignCenter>
            {label}
            {labelTooltip && (
              <InfoIndicator severity="info2" className={classes.infoIndicator} {...labelTooltipProps}>
                {labelTooltip}
              </InfoIndicator>
            )}
          </Flex>
        </Label>
        <ButtonPicker isDisabled={isDisabled} {...rest} />
      </div>
    ),
    [className, labelClassName, isDisabled, label, labelTooltip, labelTooltipProps, rest, testId]
  );

  if (tooltipDescription) {
    return (
      <Tooltip description={tooltipDescription} portal>
        {picker}
      </Tooltip>
    );
  }

  return picker;
};

const MemoizedTabsPicker = memo(TabsPicker);

export default MemoizedTabsPicker;
